/*         */
import { defineRoute } from "@kestrel/router";
import type { LoadContext } from "@kestrel/server";
import type { RouteParams } from "@kestrel/router";

import { setUpInternalInterfaces } from "./services/nexusInternal/internalNexusEvents.ts";

setUpInternalInterfaces();

export const routes = [
    defineRoute({
        path: "/trend",
        component: () => import("./cinemas/StorefrontTrendCinema.svelte"),
        server: () => import("./cinemas/StorefrontTrendCinema.server.ts"),
    }),
    defineRoute({
        path: "/lastseen",
        component: () => import("./cinemas/LastSeenArticlesCinema.svelte"),
        server: () => import("./cinemas/LastSeenArticlesCinema.server.ts"),
    }),
    defineRoute({
        path: "/entrypage",
        component: () => import("./cinemas/EntryPageCinema.svelte"),
        server: () => import("./cinemas/EntryPageCinema.server.ts"),
    }),
    defineRoute({
        path: "/storefront",
        component: () => import("./cinemas/StorefrontCinema.svelte"),
        server: () => import("./cinemas/StorefrontCinema.server.ts"),
    }),
    defineRoute({
        path: "/brand",
        component: () => import("./cinemas/BrandCinema.svelte"),
        server: () => import("./cinemas/BrandCinema.server.ts"),
    }),
    defineRoute({
        path: "/basket",
        component: () => import("./cinemas/BasketCinema.svelte"),
        server: () => import("./cinemas/BasketCinema.server.ts"),
    }),
    defineRoute({
        path: "/alternative",
        component: () => import("./cinemas/AlternativesCinema.svelte"),
        server: () => import("./cinemas/AlternativesCinema.server.ts"),
    }),
    defineRoute({
        path: "/bouncelayer",
        component: () => import("./cinemas/BounceLayerCinema.svelte"),
        server: () => import("./cinemas/BounceLayerCinema.server.ts"),
    }),
    defineRoute({
        path: "/complementary",
        component: () => import("./cinemas/ComplementaryCinema.svelte"),
        server: () => import("./cinemas/ComplementaryCinema.server.ts"),
    }),
    defineRoute({
        path: "/productline",
        component: () => import("./cinemas/ProductLineCinema.svelte"),
        server: () => import("./cinemas/ProductLineCinema.server.ts"),
    }),
    defineRoute({
        path: "/basketlayer/variations/:variationId",
        component: () => import("./cinemas/BasketLayerCinema.svelte"),
        server: () => import("./cinemas/BasketLayerCinema.server.ts"),
    }),
    defineRoute({
        path: "/emptybasket",
        component: () => import("./cinemas/EmptyBasketCinema.svelte"),
        server: () => import("./cinemas/EmptyBasketCinema.server.ts"),
    }),
    defineRoute({
        path: "/wishlist",
        component: () => import("./cinemas/WishlistCinema.svelte"),
        server: () => import("./cinemas/WishlistCinema.server.ts"),
    }),
    defineRoute({
        path: "/wishlistalternative",
        component: () => import("./cinemas/WishlistAlternativesCinema.svelte"),
        server: () => import("./cinemas/WishlistAlternativesCinema.server.ts"),
    }),
    defineRoute({
        path: "/orderoverview",
        component: () => import("./cinemas/OrderOverviewCinema.svelte"),
        server: () => import("./cinemas/OrderOverviewCinema.server.ts"),
    }),
    defineRoute({
        path: "/trend/health",
        methods: {
            GET(_: RouteParams, ctx: LoadContext) {
                ctx.json({ status: 200, body: JSON.stringify({ status: "ok" }) });
            },
        },
    }),
    defineRoute({
        path: "/internal/prometheus",
        methods: () => import("./services/observability/Prometheus.ts"),
    }),
];
